export default "__VITE_ASSET__4fC7TWKS__"